import React, { ReactNode } from 'react'
import { Box, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'

interface Props {
  main: ReactNode;
  sidebar: ReactNode;
  sidebarWidth?: number;
}

export default function SidebarLayout ({
  main,
  sidebar,
  sidebarWidth = 320
}: Props) {
  const theme = useMantineTheme()
  const mobile = useMediaQuery('(max-width: 768px)')

  if (mobile) {
    return (
      <Box>
        <Box>{main}</Box>
        <Box sx={{ width: '100%', marginTop: theme.spacing.md }}>{sidebar}</Box>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing.lg,
        alignItems: 'flex-start'
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>{main}</Box>
      <Box sx={{ width: sidebarWidth, flexShrink: 0 }}>{sidebar}</Box>
    </Box>
  )
}
